import { render, staticRenderFns } from "./alternativeLoginComponent.vue?vue&type=template&id=967eab68&scoped=true"
import script from "./alternativeLoginComponent.vue?vue&type=script&lang=js"
export * from "./alternativeLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./alternativeLoginComponent.vue?vue&type=style&index=0&id=967eab68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967eab68",
  null
  
)

export default component.exports